import React, { PropsWithChildren } from "react";
import Footer from "./Footer";
import PrivateHeader from "./header/PrivateHeader";
import { useAuth } from "../authentication/useAuth";
import LoadingIndicator from "../loading/LoadingIndicator";
import AdminModeBanner from "../banner/AdminModeBanner";

const PrivateLayout: React.FC<PropsWithChildren> = (
  props,
): React.ReactElement => {
  const { customerIsChanging } = useAuth();

  return (
    <div className="flex h-full w-full flex-col">
      <AdminModeBanner />
      <PrivateHeader />
      <div className="flex-1 px-4 sm:mx-auto">
        {customerIsChanging ? <LoadingIndicator /> : props.children}
      </div>
      <Footer />
    </div>
  );
};

export default PrivateLayout;
